export default __webpack_public_path__ + "static/media/Tracker.ec73ae1e.png";